// extracted by mini-css-extract-plugin
export default {"contentArea":"ContentArea_contentArea__ezUE6","listAndWorkshop":"ContentArea_listAndWorkshop__8OR1H"};